import React from 'react'
import CardUnit from './Card-Unit'

function Projets() {
    return (
        <div className="projets">
            <CardUnit/>
        </div>
    )
}

export default Projets
